import React from 'react';
import { withRouter } from 'react-router-dom';

class Pushtocall extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.history.push(`/call/${this.props.room_id}`)
    }

    render() {
        return <></>
    }
}
export default withRouter(Pushtocall)